export default __webpack_public_path__ + "static/media/confirm.463e2216.svg";